import React from 'react';

interface FormButtonProps {
  label: string;
  type?: 'button' | 'submit' | 'reset';
  onClick?: () => void;
  disabled?: boolean;
  variant?: 'primary' | 'secondary';
}

const FormButton: React.FC<FormButtonProps> = ({ label, type = 'button', onClick, disabled = false, variant = 'primary' }) => {
  const base = 'px-6 py-3 rounded-2xl font-semibold transition-all duration-300 transform hover:scale-105 focus:outline-none shadow-md';
  const primary = 'bg-primary-light/90 hover:bg-primary-light text-primary-dark border-none';
  const secondary = 'bg-white border-none text-primary-dark hover:bg-primary-light hover:text-white';
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${base} ${variant === 'primary' ? primary : secondary} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
    >
      {label}
    </button>
  );
};

export default FormButton;
